import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/plug-and-play/PageContent.tsx");
